import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const directProjectsRoutes: RouteObject = {
  id: "direct-projects",
  path: "/direct-projects",
  element: <DashboardPage />,
};

export default directProjectsRoutes;
